var _excluded = ["icon", "iconColor", "backgroundColor", "hasBorder", "isBig", "children", "hasBorderRadius", "onClose"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import styled, { css } from "styled-components";
import OnColorContext from "../../../contexts/OnColorContext";
var CloseIconCircle = function CloseIconCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9.78 1.282A.751.751 0 0 0 8.718.22L5 3.938 1.282.22A.751.751 0 0 0 .22 1.282L3.938 5 .22 8.718A.751.751 0 0 0 1.282 9.78L5 6.062 8.718 9.78A.751.751 0 0 0 9.78 8.718L6.062 5 9.78 1.282Z",
    fill: "#000",
    fillOpacity: ".7"
  }));
};
CloseIconCircle.defaultProps = {
  width: "10",
  height: "10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import breakpoint from "../../../utils/breakpoint";
import getBorderColor from "../../../utils/getBorderColor";
import getBorderRadius from "../../../utils/getBorderRadius";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
import IconAtm from "../../atoms/IconAtm";
import PushOrg from "../../organisms/PushOrg";
export var defaultProps = {
  isBig: false,
  hasBorderRadius: false
};
var Container = styled.div.withConfig({
  componentId: "sc-1mtmozr-0"
})(function (_ref) {
  var $backgroundColor = _ref.$backgroundColor,
    $hasBorder = _ref.$hasBorder,
    $isBig = _ref.$isBig,
    $hasBorderRadius = _ref.$hasBorderRadius,
    $hasCloseButton = _ref.$hasCloseButton,
    theme = _ref.theme;
  return css(["display:flex;align-items:", ";background:", ";", ";", ";", ""], $hasCloseButton ? "flex-start" : "center", getColor(theme, $backgroundColor), $hasBorderRadius ? css(["border-radius:", ";"], getBorderRadius(theme, "large2")) : null, $hasBorder ? css(["border:", " solid ", ";"], unit(1), getBorderColor(theme, $backgroundColor, "extraLow")) : null, $isBig ? css(["padding:", " ", ";", "{padding-right:", ";padding-left:", ";", ";}"], space(4), space(2), breakpoint("medium"), space(3), space(3), $hasBorderRadius && css(["border-radius:", ";"], getBorderRadius(theme, "large"))) : css(["padding:", " ", ";"], space(2), space($hasCloseButton ? 2 : 3)));
});
var Icon = styled(IconAtm).withConfig({
  componentId: "sc-1mtmozr-1"
})(function (_ref2) {
  var $isBig = _ref2.$isBig;
  return css(["margin-right:", ";"], space($isBig ? 3 : 1));
});
var ContentWrapper = styled.div.withConfig({
  componentId: "sc-1mtmozr-2"
})(["flex:1;"]);
var CloseButtonWrapper = styled.div.withConfig({
  componentId: "sc-1mtmozr-3"
})(["cursor:pointer;"]);
function InfoBarMol(_ref3) {
  var icon = _ref3.icon,
    iconColor = _ref3.iconColor,
    backgroundColor = _ref3.backgroundColor,
    hasBorder = _ref3.hasBorder,
    _ref3$isBig = _ref3.isBig,
    isBig = _ref3$isBig === void 0 ? defaultProps.isBig : _ref3$isBig,
    children = _ref3.children,
    _ref3$hasBorderRadius = _ref3.hasBorderRadius,
    hasBorderRadius = _ref3$hasBorderRadius === void 0 ? defaultProps.hasBorderRadius : _ref3$hasBorderRadius,
    onClose = _ref3.onClose,
    restProps = _objectWithoutProperties(_ref3, _excluded);
  return /*#__PURE__*/React.createElement(Container, _extends({
    $backgroundColor: backgroundColor,
    $isBig: isBig,
    $hasBorder: !!hasBorder,
    $hasBorderRadius: hasBorderRadius,
    $hasCloseButton: !!onClose
  }, restProps), /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: backgroundColor
  }, icon ? /*#__PURE__*/React.createElement(Icon, {
    icon: icon,
    sizeSpace: isBig ? 3 : 2,
    color: iconColor !== null && iconColor !== void 0 ? iconColor : undefined,
    $isBig: isBig
  }) : null, /*#__PURE__*/React.createElement(ContentWrapper, null, children), onClose ? /*#__PURE__*/React.createElement(PushOrg, {
    leftSpace: isBig ? 3 : 1.5,
    hasNoReset: true
  }, /*#__PURE__*/React.createElement(CloseButtonWrapper, {
    onClick: onClose
  }, /*#__PURE__*/React.createElement(IconAtm, {
    icon: CloseIconCircle,
    sizeSpace: 1.5
  }))) : null));
}
export default InfoBarMol;